import { useEffect, useState } from 'react'
import LowPriceOrderWarning from './LowPriceOrderWarning'
import SmallOrderWarning from './SmallOrderWarning'
import { useSmallOrderVerify } from '../../hooks/useTradeVerify'
import { useUSDValueSpreadCallback } from '../SpreadLabel'
import { useAccount } from 'wagmi'
import { useLimitSwapAmount } from '~/state/dex/hooks'

const OrderWarning: React.FC = () => {
  const { address: account } = useAccount()
  const { inputAmount, outputAmount } = useLimitSwapAmount()

  const [isLowPrice, setIsLowPrice] = useState(false)
  const isSmallOrder = useSmallOrderVerify()
  const calcUsdValueSpread = useUSDValueSpreadCallback()

  useEffect(() => {
    const usdValueSpread = calcUsdValueSpread()
    const isLowPrice = Number(usdValueSpread) <= -5
    setIsLowPrice(isLowPrice)
  }, [calcUsdValueSpread])

  if (!account || !inputAmount || !outputAmount) return null

  return isLowPrice ? (
    <LowPriceOrderWarning />
  ) : isSmallOrder ? (
    <SmallOrderWarning />
  ) : null
}

export default OrderWarning
